import { observable, configure } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class ShooterMarkStore extends LocalModel {
    constructor() {
        super('shooterMark', {
            namePlural: 'shooterMarks',
            namePluralReal: 'shootermarks',
            sort: '-updatedDate',
            limit: 1000,
            api: {
                search: {
                    url: '/api/shootermarks/',
                    params: {
                        limit: 1000,
                        sort: '-updatedDate',
                    },
                },
                load: {
                    url: '/api/shootermarks/',
                    params: {},
                },
                save: {
                    url: '/api/shootermarks/',
                    params: {},
                },
                delete: {
                    url: '/api/shootermarks/',
                    params: {},
                },
            },
        });
    }

    @observable shooterMark = {};

    @observable shooterMarks = [];

    // Not observable: which convention's club the loaded list belongs to.
    loadedConvention = 0;

    getMarkForUser(userId) {
        const id = parseInt(userId, 10) || 0;
        if (!id) {
            return null;
        }
        return this.shooterMarks.find(mark => mark.user === id) || null;
    }

    // Officials only — the endpoint 403s for everyone else, so only call this
    // behind the same gate that loads crew messages.
    async loadForConvention(conventionId) {
        const id = parseInt(conventionId, 10) || 0;
        if (!id) {
            return null;
        }
        const response = await util.fetchApi('/api/shootermarks/', { method: 'GET' }, {
            convention: id,
        });
        if (response?.status === 200) {
            this.loadedConvention = id;
            this.updateKeyValue('shooterMarks', response.data || []);
        }
        return response;
    }

    async saveMark({ convention, user, categories, note }) {
        const response = await util.fetchApi('/api/shootermarks/', { method: 'POST' }, {
            convention, user, categories, note,
        });
        if (response?.status === 201) {
            await this.loadForConvention(convention);
        }
        return response;
    }
}

const store = new ShooterMarkStore();

export default store;
